/**
 * Created by Phatbass on 25/02/16.
 */

var email_regexp = /^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;

angular.module('dekky.forms.validators.emailOnly', [])
    .directive('emailOnly', function(){
    return {
        require: '?ngModel',
        link: function(scope, element, attr, ngModelController) {
            ngModelController.$parsers.unshift(function (value) {
                if (email_regexp.test(value)) {
                    ngModelController.$setValidity('emailOnly', true);
                    return value;
                } else {
                    ngModelController.$setValidity('emailOnly', false);

                    return undefined;
                }
            });
        }
    };
});